<form [formGroup]="formPesquisar" (submit)="OnPesquisar()">
  <breadcrumb [paginas]="breadcrumb" />

  <section class="section-filtro">
    <app-filtro-padrao (filtroEmitter)="listeningFiltroEmitter($event)" (poloChange)="onPoloChange($event)"
      [template]="2" [style]="1" [atividadeDE]="true" [psiInativos]="true" [usePolo]="true"></app-filtro-padrao>
  </section>

  <section class="section-saudacao">
    <div class="container">
      <h2 class="titulo-page">Painel de Atividade do Coordenador</h2>
      <button type="button" class="btn_adicionar_registro btn_adicionar_jornada_antiga" [disabled]="
          !permiteInserirJornada ||
          !perfisQuePodemInserirJornadasRetroativas.includes(
            userLogado?.codigoPerfil!
          )
        " title="Adicionar Jornada Retroativa" (click)="AbrirAdicionarJornada()">
        <i aria-hidden="true" class="fa fa-plus"></i>
        <span>Adicionar Jornada Retroativa</span>
      </button>
    </div>
  </section>

  <section class="section-busca-filtro-psicologo">
    <div class="container">
      <div class="busca-psicologo">
        <p>Buscar Coordenador</p>

        <div class="conteudo-psicologo">
          <div class="grup_input">
            <label>Coordenador</label>
            <ng-select [items]="lstPsicologos" bindLabel="nomePsicologoCompleto" bindValue="codigoCPF"
              placeholder="Selecione um Coordenador" name="codigoCPF" formControlName="codigoCPF"
              class="input-psicologo" (change)="popularPsicologo(true)" [clearable]="false" [ngClass]="{
                'is-invalid': submitted && form.codigoCPF.errors
              }">
            </ng-select>
          </div>
        </div>
      </div>

      <div class="periodo">
        <p><b>Pesquisar por período:</b></p>
        <div class="periodo-input">
          <input type="date" name="dataInicio" formControlName="dataInicio" />
          &nbsp;-&nbsp;
          <input type="date" name="dataFim" formControlName="dataFim" />
        </div>
      </div>
    </div>
  </section>

  <section class="section-grid-consulta-ponto">
    <div class="container">
      <div class="row_registros">
        <h3>Listagem de Visita</h3>

        <div class="conteudo-legenda">
          <div class="legenda-acoes">
            <p>
              <b>Legenda Ações</b>
            </p>
            <div class="conteudo-acoes-legenda">
              <div class="iten-legenda">
                <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
              </div>
              <div class="iten-legenda" *ngIf="
                  perfisQuePodemAprovar.includes(userLogado?.codigoPerfil!)
                ">
                <i class="fa-regular fa-square-check" aria-hidden="true"></i> Aprovação
              </div>
              <div class="iten-legenda" *ngIf="
                  perfisJustificativaHorarioPsicologo.includes(
                    userLogado?.codigoPerfil!
                  )
                ">
                <i class="fa-solid fa-clock" aria-hidden="true"></i>
                Justificativa de Horário
              </div>

              <!-- <div
                class="iten-legenda"
                *ngIf="
                  perfisJustificativaDistancia.includes(
                    userLogado?.codigoPerfil!
                  )
                "
              >
                <i class="fa-solid fa-comment" aria-hidden="true"></i>
                Justificativa Distância
              </div> -->

              <div class="iten-legenda" *ngIf="
                  perfisJustificativaHorarioPsicologoFiscal.includes(
                    userLogado?.codigoPerfil!
                  )
                ">
                <i class="fa-solid fa-clock" aria-hidden="true"></i> Solicitação
                de ajuste do horário Coordenador
              </div>

              <div class="iten-legenda">
                <i class="fa-solid fa-edit" aria-hidden="true" *ngIf="
                    perfisEditarAtividade.includes(userLogado?.codigoPerfil!)
                  "></i>
                Edição de atividade
              </div>
              <div class="iten-legenda">
                <i class="fa-solid fa-circle-plus" aria-hidden="true" *ngIf="
                    perfisInserirAtividade.includes(userLogado?.codigoPerfil!)
                  "></i>
                Inserir atividade
              </div>
              <div class="iten-legenda">
                <i class="fa-solid fa-trash" aria-hidden="true" *ngIf="
                    perfisExcluirAtividade.includes(userLogado?.codigoPerfil!)
                  "></i>
                Excluir
              </div>
            </div>
          </div>

          <div class="legenda-aprovacao">
            <p>
              <b>Legenda Aprovação</b>
            </p>
            <div class="conteudo-aprovacao-legenda">
              <div class="iten-legenda status-validado">
                <i class="fa-solid fa-circle"></i> Validado
              </div>
              <div class="iten-legenda status-nao-validado">
                <i class="fa-solid fa-circle"></i> Não Validado
              </div>
              <div class="iten-legenda status-nao-registrado">
                <i class="fa-solid fa-circle-dot"></i> Não Registrado
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-aviso-atividade-jornada />

      <div class="grid-datatable" *ngIf="submittedPesquisa">
        <app-tabulator-table [rowFormatter]="this.rowFormatter" [tableData]="lstPainelAtividadePsicologos"
          [columnNames]="colunasGrid" [orientacaoPortrait]="false" [mostrarFiltro]="false" [mostrarImprimir]="false"
          [tableTitle]="'Atividades do Psicólogo'"></app-tabulator-table>
      </div>
    </div>
  </section>
</form>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>

<app-modal *ngIf="showModalJustificativaTempoRegistroAtividade">
  <div class="container-conviva form-registro modal-envolvidos">
    <form [formGroup]="formJustificativaTempoRegistroAtividade">
      <div class="modal-header">
        <div class="titulo-modal">
          <h2>Justificativa Tempo de Registro de Atividade</h2>
        </div>
        <button class="btn-fechar-modal" (click)="closeModalJustificativaTempoRegistroAtividade()">
          ✖
        </button>
      </div>
      <hr size="20" />
      <div class="descricao-modal-excluir">
        <label for="select-gravidade">Justificativa:</label>
        <textarea id="text-justificativaTempo" name="text-justificativaTempo" rows="6" cols="50"
          formControlName="justificativaTempoRegistroAtividade" name="justificativaTempoRegistroAtividade"
          minlength="10" maxlength="500" (keyup)="OnChangeCountLetters(1)" [ngClass]="{
            'is-invalid':
              submitted && formTempo.justificativaTempoRegistroAtividade.errors
          }" aria-describedby="descricao-error">
        </textarea>
        <p>Quantidade de caracteres atual: {{ qtdeCaracteresDescricao }}</p>
        <div *ngIf="
            submitted && formTempo.justificativaTempoRegistroAtividade.errors
          " class="alert">
          <div *ngIf="
              formTempo.justificativaTempoRegistroAtividade.errors?.required
            ">
            * Descrição da ocorrência é obrigatório.
          </div>
          <div *ngIf="
              formTempo.justificativaTempoRegistroAtividade.errors?.minlength
            ">
            * É obrigatório no mínimo digitar 10 caracteres.
          </div>
          <div *ngIf="
              formTempo.justificativaTempoRegistroAtividade.errors?.maxlength
            ">
            * Maximo de caracteres é 500.
          </div>
        </div>
      </div>
      <hr size="20" />
      <div class="container-btns">
        <input type="button" (click)="closeModalJustificativaTempoRegistroAtividade()" class="btn_primary" value="OK" />
      </div>
    </form>
  </div>
</app-modal>

<app-modal *ngIf="showModalJustificativaDistancia">
  <div class="container-conviva form-registro modal-envolvidos">
    <form [formGroup]="formJustificativaDistancia">
      <div class="modal-header">
        <div class="titulo-modal">
          <h2>Justificativa Distância</h2>
        </div>
        <button class="btn-fechar-modal" (click)="closeModalJustificativaDistancia()">
          ✖
        </button>
      </div>
      <hr size="20" />
      <div class="descricao-modal-excluir">
        <label for="select-gravidade">Justificativa:</label>
        <textarea id="text-justificativa" name="text-justificativa" rows="6" cols="50"
          formControlName="JustificativaDistancia" name="JustificativaDistancia" minlength="10" maxlength="500"
          (keyup)="OnChangeCountLetters(2)" [ngClass]="{
            'is-invalid':
              submitted && formDistancia.JustificativaDistancia.errors
          }" aria-describedby="descricao-error">
        </textarea>
      </div>
      <hr size="20" />
      <div class="container-btns">
        <input type="button" (click)="closeModalJustificativaDistancia()" class="btn_primary" value="OK" />
      </div>
    </form>
  </div>
</app-modal>

<app-modal *ngIf="showModalJustificativaCheckinOutPsicologo">
  <div class="container-conviva form-registro modal-envolvidos">

    <form [formGroup]="formEditarJornada">

      <!-- HEADER -->
      <div class="modal-header">
        <div class="titulo-modal">
          <h2 class="titulo-azul">Editar registro de jornada</h2>
        </div>
        <button class="btn-fechar-modal" type="button" (click)="closeModalJustificativaCheckinOutPsicologo()">
          ✖
        </button>
      </div>

      <!-- INFORMAÇÕES DO REGISTRO -->
      <h4>Informações do registro</h4>
      <div class="card-info-registro">


        <div class="icon-paragraph">
          <img src="../../../assets/img/icons/icon-nome-escola.svg" alt="" />
          <div class="info-bloco">
            <span class="label-info">Unidade Regional</span>
            <span class="valor-info">{{ itemEditarJornada.nomeDiretoria }}</span>
          </div>
        </div>


        <div class="icon-paragraph">
          <img src="../../../assets/img/icons/icon-nome-escola.svg" alt="" />
          <div class="info-bloco">
            <span class="label-info">Escola</span>
            <span class="valor-info">
              {{ itemEditarJornada.codigoEscola }} - {{ itemEditarJornada.nomeEscola }}
            </span>
          </div>
        </div>

        <div class="icon-paragraph">
          <img src="../../../assets/img/icons/icon-calendario.svg" alt="" />
          <div class="info-bloco">
            <span class="label-info">Data</span>
            <span class="valor-info">
              {{ itemEditarJornada.dataInicio | date:'dd/MM/yyyy' }}
            </span>
          </div>
        </div>

        <div class="icon-paragraph">
          <img src="../../../assets/img/icons/icon-relogio.svg" alt="" />
          <div class="info-bloco">
            <span class="label-info">Horário registrado</span>
            <span class="valor-info">
              {{ itemEditarJornada.dataInicio | date:'HH:mm' }} -
              {{ itemEditarJornada.dataFim | date:'HH:mm' }}
            </span>
          </div>
        </div>
      </div>
      <hr size="20" />

      <!-- NOVO HORÁRIO -->
      <div class="descricao-modal-excluir">
        <h4>Novo horário</h4>

        <div class="box-duas-colum">

          <!-- ENTRADA -->
          <div class="grupo-filter">
            <label>Horário de entrada</label>
            <input type="time" class="form-control" formControlName="horaEntrada" />

            <div class="alert" *ngIf="submitted && formEditarJornada.controls.horaEntrada.errors">
              * Campo obrigatório
            </div>
          </div>

          <!-- SAÍDA -->
          <div class="grupo-filter">
            <label>Horário de saída</label>
            <input type="time" class="form-control" formControlName="horaSaida" />

            <div class="alert" *ngIf="submitted && formEditarJornada.controls.horaSaida.errors">
              * Campo obrigatório
            </div>
          </div>

        </div>
      </div>

      <hr size="20" />

      <!-- BOTÕES -->
      <div class="container-btns">
        <input type="button" class="btn_outline" value="Cancelar"
          (click)="closeModalJustificativaCheckinOutPsicologo()" />

        <input type="button" class="btn_primary" value="Enviar para Aprovação" (click)="SalvarEdicaoJornada()" />
      </div>

    </form>
  </div>
</app-modal>

<app-modal *ngIf="showModalAdicionarJornada">
  <div class="container-conviva form-registro modal-adicionar-jornada"
    [ngClass]="{'modal-expandido-deslocamento': showSectionDeslocamento}">
    <form [formGroup]="formAdicionarJornada">
      <div class="modal-header">
        <div class="titulo-modal">
          <h2>Adicionar Jornada Retroativa</h2>
        </div>
        <button class="btn-fechar-modal" (click)="closeModalAdicionarJornada()">
          ✖
        </button>
      </div>

      <div class="descricao-modal-excluir">
        <div class="conteudo-select">
          <label>Data e Hora do Check-In: </label>
          <p *ngIf="restringeDataRetroativaJornada" class="aviso-jornada-retroativa">{{ avisoLimiteJornadaRetroativa }}
          </p>
          <input type="datetime-local" name="dataCheckIn" class="input-date" formControlName="dataCheckIn"
            aria-label="Data e Hora do Check-In" [disabled]="showModalJornadaAtividades"
            (change)="onChangeDataCheckIn()" (blur)="onBlurDataCheckIn()" [attr.min]="dataMinimaCheckInJornada"
            [attr.max]="dataMaximaCheckInJornada" />
          <div
            *ngIf="(submitted || formJornada.dataCheckIn.touched) && formJornada && formJornada.dataCheckIn && formJornada.dataCheckIn.errors"
            class="alert">
            <div *ngIf="formJornada.dataCheckIn.errors.dataFutura">{{ formJornada.dataCheckIn.errors.dataFutura }}</div>
            <div *ngIf="formJornada.dataCheckIn.errors.dataRetroativaLimite">{{
              formJornada.dataCheckIn.errors.dataRetroativaLimite }}</div>
          </div>
        </div>

        <div class="conteudo-select">
          <label>Data e Hora do Check-Out: </label>
          <input type="time" id="dataCheckOut" name="dataCheckOut" class="input-time" formControlName="dataCheckOut"
            aria-label="Data e Hora do Check-Out" [disabled]="showModalJornadaAtividades" />
        </div>

        <div class="grupo-filter-modal">
          <label>URE</label>
          <ng-select [items]="diretoriasModal" bindLabel="nomeDiretoria" bindValue="codigoDiretoria"
            placeholder="Selecione uma URE" formControlName="codigoDiretoriaModal" name="codigoDiretoriaModal"
            [searchFn]="searchUreModalFn"
            (change)="getEscolasModal()" [disabled]="showModalJornadaAtividades"
            [readonly]="diretoriasModal.length === 1">
          </ng-select>

          <div *ngIf="formJornada.codigoDiretoriaModal.errors" class="alert">
            <div *ngIf="formJornada.codigoDiretoriaModal.errors.required">
              * URE é obrigatório
            </div>
          </div>

          <div class="grupo-filter-ano">
            <p><b>Atividade na URE</b></p>
            <label>
              <input type="checkbox" [checked]="this.atividadeDiretoria" class="checkbox"
                (change)="OnChangeApenasDiretoria()" [disabled]="showModalJornadaAtividades" /><i></i>
            </label>
          </div>
        </div>

        <div class="grupo-filter-modal">
          <label>Escola</label>
          <ng-select [items]="escolasModal" bindLabel="nomeEscola" bindValue="codigoEscola"
            placeholder="Selecione uma Escola" formControlName="codigoEscolaModal" name="codigoEscolaModal"
            [searchFn]="searchEscolaModalFn"
            (change)="onChangeEscolaModalJornada()" [disabled]="showModalJornadaAtividades">
          </ng-select>
          <div *ngIf="formJornada.codigoEscolaModal.errors" class="alert">
            <div *ngIf="formJornada.codigoEscolaModal.errors.required">
              * Escola é obrigatório
            </div>
          </div>
        </div>

        <div class="grupo-filter-modal">
          <label for="text-JustificativaSolicitacao">Justificação da Solicitação:</label>
          <textarea id="text-JustificativaSolicitacao" name="text-JustificativaSolicitacao" rows="6" cols="50"
            formControlName="JustificativaSolicitacao" name="JustificativaSolicitacao" minlength="10" maxlength="500"
            (keyup)="OnChangeCountLetters(4)" [ngClass]="{
              'is-invalid':
                submitted && formJornada.JustificativaSolicitacao.errors
            }" aria-describedby="descricao-error" [disabled]="showModalJornadaAtividades"></textarea>
          <p>Quantidade de caracteres atual: {{ qtdeCaracteresDescricao }}</p>
          <div *ngIf="submitted && formJornada.JustificativaSolicitacao.errors" class="alert">
            <div *ngIf="formJornada.JustificativaSolicitacao.errors?.required">
              * Descrição da ocorrência é obrigatório.
            </div>
            <div *ngIf="formJornada.JustificativaSolicitacao.errors?.minlength">
              * É obrigatório no mínimo digitar 10 caracteres.
            </div>
            <div *ngIf="formJornada.JustificativaSolicitacao.errors?.maxlength">
              * Maximo de caracteres é 500.
            </div>
          </div>
        </div>

        @if(this.showBotonDeslocamento){
        <div class="grupo-filter-modal">
          <input type="button" (click)="toggleDeslocamento()"
            [class]="showSectionDeslocamento ? 'btn_outline' : 'btn_primary'"
            [value]="showSectionDeslocamento ? 'Sem deslocamento' : 'Deslocamento'" />
        </div>
        }

      </div>

      @if(showSectionDeslocamento){
      <div class="deslocamento">

        <div class="box-duas-colum">

          <div class="grupo-filter">
            <p><b>URE Origem</b></p>
            <ng-select [items]="diretoriasOrigem" bindLabel="nomeDiretoria" bindValue="codigoDiretoria"
              placeholder="Selecione uma URE" formControlName="codigoDiretoriaOrigem" name="codigoDiretoriaOrigem"
              (change)="trocaDiretoriaOrigem()"
              [ngClass]="{ 'is-invalid': submitted && formJornada.codigoDiretoriaOrigem.errors }">
            </ng-select>
            <div *ngIf="submitted && formJornada.codigoDiretoriaOrigem.errors" class="alert">
              <div *ngIf="formJornada.codigoDiretoriaOrigem.errors.required">
                * URE Origem é obrigatório
              </div>
            </div>

            <div class="grupo-filter-ano">
              <p><b>Atividade na URE</b></p>
              <label>
                <input type="checkbox" [checked]="this.atividadeDiretoriaOrigem" class="checkbox"
                  (change)="OnChangeApenasDiretoriaOrigem()" /><i></i>
              </label>
            </div>
          </div>

          <div class="grupo-filter">
            <p><b>Escola Origem</b></p>
            <ng-select [items]="escolasOrigem" bindLabel="nomeEscola" bindValue="codigoEscola"
              placeholder="Selecione uma Escola" formControlName="codigoEscolaOrigem" name="codigoEscolaOrigem"
              [searchFn]="searchEscolaModalFn"
              (change)="removerRota()" [ngClass]="{ 'is-invalid': submitted && formJornada.codigoEscolaOrigem.errors }">
            </ng-select>
            <div *ngIf="submitted && formJornada.codigoEscolaOrigem.errors" class="alert">
              <div *ngIf="formJornada.codigoEscolaOrigem.errors.required">
                * Escola é obrigatório
              </div>
            </div>
          </div>

          <div class="grupo-filter">
            <p><b>Transporte</b></p>
            <ng-select [items]="lstTipoTransporte" bindLabel="name" bindValue="id"
              placeholder="Selecione uma Forma de Transporte" formControlName="codigoTipoTransporte"
              name="codigoTipoTransporte" (change)="removerRota()"
              [ngClass]="{ 'is-invalid': submitted && formJornada.codigoTipoTransporte.errors }">
            </ng-select>
            <div *ngIf="submitted && formJornada.codigoTipoTransporte.errors" class="alert">
              <div *ngIf="formJornada.codigoTipoTransporte.errors.required">
                * Tipo de Transporte é obrigatório
              </div>
            </div>
          </div>

          <div class="grupo-filter">
            <p><b>Horário Saída: (hh:mm)</b></p>
            <input type="time" formControlName="horarioSaida" (blur)="trocaHoraSaida()" />
            <div *ngIf="submitted && formJornada.horarioSaida.errors" class="alert">
              <div *ngIf="formJornada.horarioSaida.errors.required">
                *Horário de Saída é obrigatório
              </div>
            </div>
          </div>

        </div>
        <div class="box-duas-colum">

          <div class="grupo-filter">
            <p><b>Tempo de Deslocamento:</b></p>
            <input type="time" formControlName="tempoDeslocamento" />

            <div *ngIf="submitted && formJornada.tempoDeslocamento.errors" class="alert">
              <div *ngIf="formJornada.tempoDeslocamento.errors.required">
                *Tempo de Deslocamento é obrigatório
              </div>
            </div>
          </div>

          <div class="grupo-filter">
            <p><b>Horário Chegada: (hh:mm)</b></p>
            <input type="time" formControlName="horarioChegada" />
            <div *ngIf="submitted && formJornada.horarioChegada.errors" class="alert">
              <div *ngIf="formJornada.horarioChegada.errors.required">
                *Horário Chegada é obrigatório
              </div>
            </div>
          </div>

          <div class="grupo-filter">
            <p><b>Quilômetro Percorrido: (KM)</b></p>
            <input type="number" formControlName="kmPercorrido" />
            <div *ngIf="submitted && formJornada.kmPercorrido.errors" class="alert">
              <div *ngIf="formJornada.kmPercorrido.errors.required">
                *Quilômetro Percorrido é obrigatório
              </div>
            </div>
          </div>
        </div>

        <div class="container-btns-visitas">
          <input type="button" class="btn_primary" value="Gerar Deslocamento" (click)="gerarRota()" />
        </div>

        <div id="map" style="height: 400px; display: none;"></div>

      </div>

      }

      <hr size="20" />

      @if(!showModalJornadaAtividades){
      <div class="container-btns">
        <input type="button" (click)="closeModalAdicionarJornada()" class="btn_outline" value="Cancelar"
          [disabled]="showModalJornadaAtividades" />
        <input type="button" (click)="RevisarJornada()" class="btn_primary" value="Inserir Jornada Retroativa"
          [disabled]="showModalJornadaAtividades" />
      </div>
      } @else{
      <p><b>Deseja inserir uma nova atividade na jornada retroativa?</b></p>

      <div class="container-btns adicionar-atividade-jornada-antiga">
        <input type="button" (click)="redirectToAddAtividade()" class="btn_primary" value="Adicionar Atividade"
          [disabled]="userLogado?.codigoPerfil == 1632" />
        <input type="button" (click)="closeModalAdicionarJornada()" class="btn_outline" value="Fechar" />
      </div>
      }
    </form>
  </div>
</app-modal>


<app-modal class="modal-overlay" *ngIf="showModalAprovacao">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Enviar Atividades para aprovação?</h2>
      </div>
      <button class="btn-fechar-modal" (click)="toggleModalAprovacao()">
        ✖
      </button>
    </div>
    <br />
    <div class="modal-footer">
      <button class="btn_segundario" (click)="toggleModalAprovacao()">
        Não
      </button>
      <button class="btn_primeiro" (click)="EnviarAtividades()">Sim</button>
    </div>
  </div>
</app-modal>

<app-modal class="modal-overlay" *ngIf="showModalExcluirAtividade">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Deseja excluir o Registro da Atividade?</h2>
      </div>
      <button class="btn-fechar-modal" (click)="toggleModalExcluirAtividade()">
        ✖
      </button>
    </div>
    <br />
    <div class="modal-footer">
      <button class="btn_segundario" (click)="toggleModalExcluirAtividade()">
        Não
      </button>
      <button class="btn_primeiro" (click)="OnExcluirAtividade()">Sim</button>
    </div>
  </div>
</app-modal>

<app-modal class="modal-overlay" *ngIf="showModalExcluirJornada">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Deseja excluir o Registro da Jornada?</h2>
      </div>
      <button class="btn-fechar-modal" (click)="toggleModalExcluirJornada()">
        ✖
      </button>
    </div>
    <br />
    <div class="modal-footer">
      <button class="btn_segundario" (click)="toggleModalExcluirJornada()">
        Não
      </button>
      <button class="btn_primeiro" (click)="OnExcluirJornada()">Sim</button>
    </div>
  </div>
</app-modal>

<app-modal *ngIf="showModalDeslocamento">
  <div class="container-conviva form-registro modal-envolvidos modal-visita-psicologo">
    <div class="header-modal-filtro">
      <h1 class="titulo-page">Deseja fazer um deslocamento ?</h1>
      <a class="btn-fechar-modal" (click)="FecharModalDeslocamento()">fechar</a>
    </div>

    <div class="time-line conteudo-registro modal-conteudo-busca-aluno">
      <div class="container-btns">
        <input type="button" (click)="FecharModalDeslocamento()" class="btn_outline" value="Não" />
        <input type="submit" class="btn_primary" (click)="SectionDeslocamento()" value="Sim" />
      </div>
    </div>
  </div>
</app-modal>
